// extracted by mini-css-extract-plugin
module.exports = {"default":"CenteredPage_default__S9eu1"};